import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter } from 'el-transition'

// Connects to data-controller="transition"
export default class extends Controller {
  static targets = [
    'transitionContent',
  ]

  declare readonly transitionContentTarget: HTMLElement

  connect (): void {
    enter(this.transitionContentTarget)
  }
}
